import { act } from 'react-test-renderer';
import { searchSetting } from '../constants';

const initialState = {
  process_fetch_count:0, // check api processing count
  fetchStatus:{},
// checkbox state replace from checkedFromRedux to source 2020 10 14 ------------------ //
  checkedFromRedux:[],
  channelFromRedux:[],
  filterTypeFromRedux: 1,
  source: [],
  sourceNot: [],
  type:[],
  typeNot:[],
  typeTag:[],
  typeNotTag:[],
// ------------------------------ //
// --------------等釐清用途之後整合 2020 10 12
  channel: [],      //not know
  channelNot: [],   //not know
  ch:[],            //for mediafilter stored search condition
  chNot:[],         //for mediafilter stored search condition
// -----------------
  glb_type: [],
  author: [],
  authorNot: [],
  doc: [],
  docNot: [],
  docTag: '',
  docNotTag: '',
  sourceTag: [],
  channelTag: [],//待修正 2020 1012
  sourceNotTag: [],
  channelNotTag: [],//待修正 2020 1012
  serachKeyword: '',
  abbKeyword: false,
  autophrase: false,
  status:'過去7天',
  savedKeyword:'',
  savedKeywords: [],
  savedHistoryLog:[],
  savedAuthors: [],
  selectedAuthor: [],
  savedDocs: [],
  selectedDocs: [],
  savedMediaList: [],
  exact: 'N',
  checkedList: [
    {type: 'NEWS', checked: []},
    {type: 'BBS', checked: []},
    {type: 'SM', checked: []},
    {type: 'BLOG', checked: []},
  ],
  selectedMediaType: [false, false, false, false],
  availableWidgets: [],
  selectedMediaId: null,
  keepMediaListId: false,
  savedAlerts: [],
  selectedAlertId: null,
  keywordFromGuide: '',
  diffusionStting: {
    "b_weight": 1,
    "l_weight": 1,
    "r_weight": 1,
    "s_weight": 1,
  },
  chKeys: [],
  chNotKeys: [],
// ----------- group ------------
  authorGroup : [],
  sourceGroup : [],
  channelGroup : [],
  docGroup : [],
  authorGroupNot : [],
  sourceGroupNot : [],
  channelGroupNot : [],
  docGroupNot : [],
  keywordColor:'#fff',
};

export function search(state = initialState, action) {
  switch (action.type) {
    case searchSetting.REQUEST_FETCH_API:
      return{
        ...state,
        process_fetch_count: state.process_fetch_count+1
      }
    case searchSetting.RECEIVE_FETCH_API:
      return{
        ...state,
        fetchStatus: Object.assign({}, action.fetchStatus ,state.fetchStatus),
        process_fetch_count: state.process_fetch_count-1
      }
    case searchSetting.REQUEST_MYHISTORYLOG:
      return { 
        ...state,
      };
    case searchSetting.RECEIVE_MYHISTORYLOG:
      return {
        ...state,
        savedHistoryLog: action.savedHistoryLog,
        // lastUpdated: action.receivedAt
      };
    case searchSetting.REQUEST_KEYWORD:
      return { ...state };
    case searchSetting.RECEIVE_KEYWORD:
      return {
        ...state,
        savedKeywords: action.savedKeywords,
        // lastUpdated: action.receivedAt
      };
    case searchSetting.RECEIVE_KEYWORD_COLOR:
      return{
        ...state,
        keywordColor: action.keywordColor ? action.keywordColor : state.keywordColor,
      }
    case searchSetting.A_KEYWORD:
      return {
        ...state,
        autophrase:action.autophrase,
        serachKeyword: action.serachKeyword,
        abbKeyword: action.abbKeyword,
        keywordFromGuide: action.keywordFromGuide,
        lastUpdated: action.receivedAt
      };
    case searchSetting.S_KEYWORD:
      return {
        ...state,
        savedKeyword: action.savedKeyword,
        savedKeywords: state.savedKeywords.concat(action.savedKeyword)
      };
    case searchSetting.GET_DATE:
      return {
        ...state,
        sDate: action.sDate,
        eDate: action.eDate,
        sDateHyphen: action.sDateHyphen,
        eDateHyphen: action.eDateHyphen,
        // lastUpdated: action.receivedAt
      };
    case searchSetting.SET_TIME_STATUS:
      return{
        ...state,
        status:action.status ? action.status:state.status,
      }
    case searchSetting.A_MEDIA:
      return {
        ...state,
        source: action.source,
        checkedFromRedux: action.checkedFromRedux,
        filterTypeFromRedux: 1,
        // lastUpdated: action.receivedAt
      };
    case searchSetting.A_NOT_MEDIA:
      return {
        ...state,
        sourceNot: action.sourceNot,
        checkedFromRedux: action.checkedFromRedux,
        filterTypeFromRedux: 2,
        // lastUpdated: action.receivedAt
      };
    case searchSetting.A_MEDIA_CLEAN:
      return {
        ...state,
        source: [],
        channel: [],
      };
    case searchSetting.A_NOT_MEDIA_CLEAN:
      return {
        ...state,
        sourceNot: [],
        channelNot: [],
      };
    case searchSetting.A_TYPE:
      return {
        ...state,
        typeTag:action.typeTag ? action.typeTag : state.typeTag,
        typeNotTag:action.typeNotTag ? action.typeNotTag : state.typeNotTag,
        glb_type: action.mediaType ? action.mediaType : state.glb_type,
        checkedList: action.checkedList ? action.checkedList : state.checkedList,
        selectedMediaType: action.selectedMediaType ? action.selectedMediaType : state.selectedMediaType,
        // lastUpdated: action.receivedAt
      };
      case searchSetting.REMOVE_TYPE:
        return{
          ...state,
          selectedMediaType:action.selectedMediaType,
          glb_type:action.glb_type
        }
    // add media filter from result widget, show the filter in filter component

    // 2020 10 30 這裡的type tag 跟 filter的 typetag 撞到 目前推測無用。
    case searchSetting.A_MEDIA_FROM_ARTICLE:
      return {
        ...state,
        // typeTag: action.typeTag ? state.typeTag.concat(action.typeTag) : state.typeTag,
        // sourceTag: action.sourceTag ? state.sourceTag.concat(action.sourceTag) : state.sourceTag,
        // channelTag: action.channelTag ? state.channelTag.concat(action.channelTag) : state.channelTag,
        ch : action.ch ? state.ch.concat(action.ch) : state.ch,
        chNot : action.chNot ? state.chNot.concat(action.chNot) : state.chNot,
        source : action.source ? state.source.concat(action.source) : state.source,
        sourceNot : action.sourceNot ? state.sourceNot.concat(action.sourceNot) : state.sourceNot,
        chKeys : action.chKeys ? state.chKeys.concat(action.chKeys) : state.chKeys,
        lastUpdated: action.receivedAt
      };
    case searchSetting.A_NOT_MEDIA_FROM_ARTICLE:
      return {
        ...state,
        sourceNotTag: action.sourceNotTag ? state.sourceNotTag.concat(action.sourceNotTag) : state.sourceNotTag,
        channelNotTag: action.channelNotTag ? state.channelNotTag.concat(action.channelNotTag) : state.channelNotTag,
        lastUpdated: action.receivedAt
      };
    case searchSetting.FILTER_ACTION:
      return {
        ...state,
        filterTypeFromRedux: action.filterTypeFromRedux
      };
    case searchSetting.SEARCH_METHOD:
      return {
        ...state,
        exact: action.exact,
        // lastUpdated: action.receivedAt
      };
    case searchSetting.CLEAN_ALL:
        return{
          ...state,
          author: [],
          authorNot: [],
          doc: [],
          docNot: [],
          source: [],
          sourceNot: [],
          checkedFromRedux: [],
          channelFromRedux: [],
          checkedList: [
            {type: 'NEWS', checked: []},
            {type: 'BBS', checked: []},
            {type: 'SM', checked: []},
            {type: 'BLOG', checked: []},
          ],
          ch: [],
          chNot: [],
          chKeys: [],
          chNotKeys: [],
          typeTag:[],
          typeNotTag:[],
          glb_type:[],

          authorGroup : [],
          sourceGroup : [],
          channelGroup : [],
          docGroup : [],

          authorGroupNot : [],
          sourceGroupNot : [],
          channelGroupNot : [],
          docGroupNot : [],

          selectedMediaType:[false,false,false,false],
          lastUpdated: action.receivedAt
        }

    case searchSetting.REMOVE_FILTER: // delete tag 2020 10 08

      return {
        ...state,
        author: action.author ? action.author : state.author,
        authorNot: action.authorNot ? action.authorNot : state.authorNot,
        doc: action.doc ? action.doc : state.doc,
        docNot: action.docNot ? action.docNot : state.docNot,

        typeTag:action.typeTag ? action.typeTag : state.typeTag,
        typeNotTag:action.typeNotTag ? action.typeNotTag : state.typeNotTag,

        // type: action.type ? action.type : state.type,
        // typeNot: action.typeNot ? action.typeNot : state.typeNot,

        source: action.source ? action.source : state.source,
        sourceNot: action.sourceNot ? action.sourceNot : state.sourceNot,

        // checkedList: action.checkedList ? action.checkedList : state.checkedList,
        checkedFromRedux: action.checked ? action.checked :state.checkedFromRedux,
        channelFromRedux: action.channelFromRedux ? action.channelFromRedux : state.channelFromRedux,

        // Warning：(2020 10 23) 鬼之更新=>明明在 search.action沒有傳值過來卻被更新了
        // => 推斷是因為在 search.action 裡 getState 時 call by reference 改動後的值直接被更新到 stroe
        // => 目前結果來看是正確的，但這不是 redux 的運作原理，所以備註在這裡。
        // checkedList:action.checkedList? action.checkedList :state.checkedList,

        ch: action.ch ? action.ch : state.ch,
        chNot: action.chNot ? action.chNot : state.chNot,

        chKeys: action.chKeys ? action.chKeys : state.chKeys,
        chNotKeys: action.chNotKeys ? action.chNotKeys :state.chNotKeys,

        lastUpdated: action.receivedAt
      };
    case searchSetting.REMOVE_GROUP_FILTER: 
      return {
        ...state,
        author: action.author ? action.author : state.author,
        authorNot: action.authorNot ? action.authorNot : state.authorNot,
        source: action.source ? action.source : state.source,
        sourceNot: action.sourceNot ? action.sourceNot : state.sourceNot,
        doc: action.doc ? action.doc : state.doc,
        docNot: action.docNot ? action.docNot : state.docNot,
        chKeys: action.chKeys ? action.chKeys : state.chKeys,
        chNotKeys: action.chNotKeys ? action.chNotKeys :state.chNotKeys,

        authorGroup : action.authorGroup ? action.authorGroup : state.authorGroup,
        authorGroupNot: action.authorGroupNot ? action.authorGroupNot : state.authorGroupNot,
        sourceGroup : action.sourceGroup ? action.sourceGroup : state.sourceGroup,
        sourceGroupNot : action.sourceGroupNot ? action.sourceGroupNot : state.sourceGroupNot,
        channelGroup : action.channelGroup ? action.channelGroup : state.channelGroup,
        channelGroupNot : action.channelGroupNot ? action.channelGroupNot : state.channelGroupNot,
        docGroup : action.docGroup ? action.docGroup : state.docGroup,
        docGroupNot : action.docGroupNot ? action.docGroupNot : state.docGroupNot,
      };
    case searchSetting.REQUEST_MYAUTHOR:
      return {
        ...state
      };
    case searchSetting.RECEIVE_MYAUTHOR:
      return {
        ...state,
        savedAuthors: action.savedAuthors,
        selectedAuthor: action.selectedAuthor
      };
    case searchSetting.APPLY_AUTHOR:
      return {
        ...state,
        author: state.author.concat(action.author),
        // lastUpdated: action.receivedAt
      };
    case searchSetting.APPLY_NOT_AUTHOR:
      return {
        ...state,
        authorNot: state.authorNot.concat(action.authorNot),
        // lastUpdated: action.receivedAt
      };
    case searchSetting.SELECT_AUTHOR:
      return {
        ...state,
        selectedAuthor: action.selectedAuthor
      };
    case searchSetting.REQUEST_MYDOC:
      return {
        ...state
      };
    case searchSetting.RECEIVE_MYDOC:
      return {
        ...state,
        savedDocs: action.savedDocs,
        selectedDocs: action.selectedDocs
      };
    case searchSetting.SELECT_DOC:
      return {
        ...state,
        selectedDocs: action.selectedDocs
      };
    case searchSetting.REQUEST_MYMEDIA:
      return {
        ...state
      };
    case searchSetting.RECEIVE_MYMEDIA:
      return {
        ...state,
        savedMediaList: action.savedMediaList,
        selectedMediaId: action.keepMediaListId ? state.selectedMediaId : action.savedMediaList.length > 0 ? action.savedMediaList[0].id : null
      };
    case searchSetting.SELECT_MYMEDIA:
      return {
        ...state,
        selectedMediaId: action.selectedMediaId
      };
    case searchSetting.REQUEST_MYWIDGETS:
      return {
        ...state
      };
    case searchSetting.RECEIVE_MYWIDGETS:
      return {
        ...state,
        availableWidgets: action.availableWidgets,
      };
    // case searchSetting.BLOCK_DOC:
    //   return {
    //     ...state,
    //     docNot: state.docNot.concat(action.docNot),
    //     lastUpdated: action.receivedAt
    //   };
    case searchSetting.APPLY_DOC:
      return {
        ...state,
        doc: state.doc.concat(action.doc),
        // lastUpdated: action.receivedAt
      };
    case searchSetting.APPLY_NOT_DOC:
      return {
        ...state,
        docNot: state.docNot.concat(action.docNot),
        // lastUpdated: action.receivedAt
      };
    case searchSetting.APPLY_NOT_AUTHOR:
      return {
        ...state,
        docNot: state.docNot.concat(action.docNot),
        lastUpdated: action.receivedAt
      };
    case searchSetting.REQUEST_MYALERTS:
      return {
        ...state
      };
    case searchSetting.RECEIVE_MYALERTS:
      return {
        ...state,
        savedAlerts: action.savedAlerts,
        selectedAlertId: action.selectedAlertId
      };
    case searchSetting.CHANGE_SELECT_ALERT_ID:
      return {
        ...state,
        selectedAlertId: action.selectedAlertId,
      };
    case searchSetting.REQUEST_MYDIFFS:
      return {
        ...state
      };
    case searchSetting.RECEIVE_MYDIFFS:
      return {
        ...state,
        diffusionStting: action.diffusionStting,
      };
    case searchSetting.RECEIVE_MY_DIFFUSION_SET:
      let diffusing ={
        user_email:state.diffusionStting.user_email,
        ...action.diffusionStting,
      }
      return{
        ...state,
        diffusionStting: diffusing,
      }
    case searchSetting.A_CHKEY:
      if(action.filter===1){
        return{
          ...state,
          chKeys: action.chKeys,
          chNotKeys: action.chNotKeys,
          ch:action.ch,
          chNot:action.chNot,
          channelFromRedux:action.ch,
        }
      }
      else{
        return {
          ...state,
          chKeys: action.chKeys,
          chNotKeys: action.chNotKeys,
          ch:action.ch,
          chNot:action.chNot,
          channelFromRedux:action.chNot,
          // lastUpdated: action.receivedAt
        }
      }
    case searchSetting.APPLY_AG:
      return {
        ...state,
        authorGroup: action.authorGroup ? state.authorGroup.concat(action.authorGroup) : state.authorGroup,
      }
    case searchSetting.APPLY_NOT_AG:
      return {
        ...state,
        authorGroupNot: action.authorGroupNot ? state.authorGroupNot.concat(action.authorGroupNot) : state.authorGroupNot,
      }
    case searchSetting.APPLY_DG:
      return {
        ...state,
        docGroup : action.docGroup ? state.docGroup.concat(action.docGroup) : state.docGroup,
      }
    case searchSetting.APPLY_NOT_DG:
      return {
        ...state,
        docGroupNot: action.docGroupNot ? state.docGroupNot.concat(action.docGroupNot) : state.docGroupNot,
      }
    case searchSetting.APPLY_SG:
      return {
        ...state,
        sourceGroup:action.sourceGroup ? state.concat(action.sourceGroup) : state.sourceGroup
      }
    case searchSetting.APPLY_NOT_SG:
      return {
        ...state,
        sourceGroupNot:action.sourceGroupNot ? state.concat(action.sourceGroupNot) : state.sourceGroupNot
      }
  default:
    return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/search.reducer.js